import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
    },
    contentBtn: {
        position: 'absolute',
        bottom: 60,
        paddingHorizontal: 25,
        width: '100%'
    },
    titularityText: {
        marginTop: 20,
        color: "#FF0000",
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    }
});

export default styles;
